import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";

export const ClearSelectedVmiBinsChangedQty: Handler = props => {
    props.dispatch({
        type: "Pages/VmiBins/ClearSelectedVmiBinsChangedQty",
    });
};

export const chain = [ClearSelectedVmiBinsChangedQty];

const clearSelectedVmiBinsChangedQty = createHandlerChainRunnerOptionalParameter(
    chain,
    {},
    "ClearSelectedVmiBinsChangedQty",
);
export default clearSelectedVmiBinsChangedQty;
